module.exports = __webpack_public_path__ + "static/media/DeductIcon.6c331ee7.svg";